<template>
    <section class="tables landing-page">
        <vue-snotify></vue-snotify>
        <div class="row mt-5">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">List of email</h4>
                    </div>
                    <div class="card-body">
                        <form action="" method="post">
                            <div class="row">
                                <div class="col-md-4 col-sm-6">
                                    <div role="group" class="form-group">
                                        <div>
                                            <input id="search" name="search" v-model="searchIndex.search"
                                                @keyup="searchMarket" type="search" placeholder="Search"
                                                class="form-control form-control-sm">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-6">
                                    <div role="group" class="form-group">
                                        <div>
                                            <select class="custom-select" @change="groupBox" id="GroupID"
                                                v-model="searchIndex.GroupID" name="GroupID">
                                                <option option="" value="1">Select Group</option>
                                                <option value="f1">Group 1</option>
                                                <option value="f2">Group 2</option>
                                                <option value="1">Currents</option>
                                                <option value="0">Pasts</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
<CircleLoader v-if="isLoading" />
                        <vue-good-table mode="remote" @on-page-change="onPageChange" @on-per-page-change="onPerPageChange"
                            
                            v-else
                            :totalRows="tableConfig.totalRecords" 
                            :pagination-options="tableConfig.options" :rows="emailList" :sort-options="{
                                enabled: true,
                                multipleColumns: true,
                                initialSortBy: searchIndex.sort[0]
                            }" :columns="tableConfig.columns" @on-sort-change="onSortChange">
                        </vue-good-table>
                    </div>
                </div>
            </div>

        </div>

    </section>
</template>

<script>
import Vue from "vue";
import API from "@/api";

export default {
    data() {
        return {
            searchTime: '',
            searchIndex: {
                search: "",
                GroupID: 1,
                sort: [
                    {
                        field: 'email', // example: 'name'
                        type: 'asc' // 'asc' or 'desc'
                    }
                ],
                page: 1, // what page I want to show
                perPage: 10
            },
            emailList: {
                name: "",
                email: "",
                status: ""
            },
           isLoading: false,
            tableConfig: {
                columns: [
                    {
                        label: 'Name',
                        field: 'name',
                        type: 'text',
                        sortable: true,
                    },
                    {
                        label: 'Email',
                        field: 'email',
                        type: 'text',
                        sortable: true,
                    },
                    {
                        label: 'Status',
                        field: "status",
                        type: 'text',
                        sortable: true,
                    }
                ],
                options: {
                    enabled: true,
                    dropdownAllowAll: false,
                    perPageDropdown: [10, 20, 50, 100, 200],
                },
                totalRecords: 0,
                isLoading: false
            }
        }
    },
    methods: {
        onSortChange(e){
            let typ = (this.searchIndex.sort[0].type=='asc'?'desc':'asc')
            this.searchIndex.sort[0].field = e[0].field;
            this.searchIndex.sort[0].type = typ;
            this.getMarketingEmailList();
        },
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.getMarketingEmailList();
        },
        onPerPageChange(params) {
            this.updateParams({ perPage: params.currentPerPage });
            this.getMarketingEmailList();
        },
        updateParams(newProps) {
            this.searchIndex = Object.assign({}, this.searchIndex, newProps);
        },
        getMarketingEmailList() {
            API.getMarketingEmailList(this.searchIndex, this.emailListCB, this.errorCB);
        },
        groupBox() {
            this.getMarketingEmailList();
        },
        searchMarket() {
            clearTimeout(this.searchTime);
            this.searchTime = setTimeout(() => {
                this.getMarketingEmailList();
            }, 1000)
        }
        ,
        emailListCB(response) {
            this.tableConfig.totalRecords = response.data.total;
            let resData = response.data.data.map(data => {
                return {
                    name: data.FirstName + " " + data.LastName,
                    email: data.email,
                    status: data.Status
                }
            })
            this.emailList = resData
            this.isLoading = false;
        },
        errorCB(err) {
            console.log(err);
            this.$showNotification({ message: 'Failed system error' }, "error")
            this.isLoading = false;
        }
    },
    mounted() {
        this.isLoading = true;
        this.getMarketingEmailList();
    }
}
</script>